<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
        fill="currentColor"
    ><!--!Font Awesome Free v7.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
        <path d="M224 96C206.3 96 192 110.3 192 128C192 145.7 206.3 160 224 160L288 160L288 480L224 480C206.3 480 192 494.3 192 512C192 529.7 206.3 544 224 544L416 544C433.7 544 448 529.7 448 512C448 494.3 433.7 480 416 480L352 480L352 128C352 110.3 337.7 96 320 96L224 96z"/>
    </svg>
</template>